import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
// import { ArrowLeftIcon } from '@heroicons/react/24/outline';
// import SeatReservationWithPayment from '../components/seat/SeatReservationWithPayment'; // TODO: 컴포넌트 구현 필요
import DynamicPricingDisplay from '../components/pricing/DynamicPricingDisplay';

const SeatReservationPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const selectedSeat = searchParams.get('seat');
  const [selectedDuration, setSelectedDuration] = useState(2); // 기본 2시간

  const handleReservationComplete = (reservation: any) => {
    // 예약 완료 후 대시보드로 이동하거나 시간 추적 페이지로 이동
    setTimeout(() => {
      navigate('/time-tracking');
    }, 2000);
  };

  const handleCancel = () => {
    navigate(-1); // 이전 페이지로 돌아가기
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        {/* 헤더 */}
        <div className="mb-6">
          <button
            onClick={handleCancel}
            className="flex items-center text-gray-600 hover:text-gray-800 mb-4"
          >
            ←
            좌석 선택으로 돌아가기
          </button>
          
          <div className="bg-white rounded-lg shadow-sm p-6">
            <h1 className="text-2xl font-bold text-gray-900 mb-2">
              좌석 예약 및 결제
            </h1>
            <p className="text-gray-600">
              원하는 좌석을 예약하고 이용권을 구매하거나 보유 이용권을 사용하세요.
            </p>
            {selectedSeat && (
              <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-md">
                <p className="text-blue-800">
                  <span className="font-medium">선택된 좌석:</span> {selectedSeat}
                </p>
              </div>
            )}
          </div>
        </div>

        {/* 메인 컨텐츠 */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* 좌석 예약 */}
          <div className="lg:col-span-2">
            {/* TODO: SeatReservationWithPayment 컴포넌트 구현 후 주석 해제
            <SeatReservationWithPayment
              selectedSeat={selectedSeat || undefined}
              onReservationComplete={handleReservationComplete}
              onCancel={handleCancel}
            />
            */}
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <p className="text-gray-500">좌석 예약 기능이 준비 중입니다.</p>
            </div>
          </div>

          {/* 동적 가격 정보 */}
          <div className="lg:col-span-1">
            <DynamicPricingDisplay
              selectedSeat={selectedSeat || undefined}
              durationHours={selectedDuration}
              onPriceUpdate={(pricing) => {
                // 가격 업데이트 처리
              }}
            />
          </div>
        </div>

        {/* 도움말 섹션 */}
        <div className="mt-8 bg-white rounded-lg shadow-sm p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">
            💡 이용 안내
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <h4 className="font-medium text-gray-900 mb-2">좌석 예약</h4>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• 원하는 좌석을 선택하여 즉시 예약</li>
                <li>• 예약과 동시에 자동 시간 추적 시작</li>
                <li>• 좌석별 실시간 가격 확인 가능</li>
              </ul>
            </div>
            <div>
              <h4 className="font-medium text-gray-900 mb-2">이용권 사용</h4>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• 보유 이용권 우선 사용</li>
                <li>• 이용권이 없으면 현장 구매</li>
                <li>• 사용량에 따른 자동 정산</li>
              </ul>
            </div>
            <div>
              <h4 className="font-medium text-gray-900 mb-2">결제 방법</h4>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• 신용/체크카드</li>
                <li>• 카카오페이</li>
                <li>• 토스페이</li>
              </ul>
            </div>
            <div>
              <h4 className="font-medium text-gray-900 mb-2">환불 정책</h4>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• 30분 미만 사용: 전액 환불</li>
                <li>• 1시간 미만 사용: 50% 환불</li>
                <li>• 1시간 이상 사용: 환불 불가</li>
              </ul>
            </div>
            <div>
              <h4 className="font-medium text-gray-900 mb-2">동적 가격 정책</h4>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• 피크시간: 30% 할증 (9-12시, 14-18시, 19-22시)</li>
                <li>• 심야시간: 20% 할인 (22-7시)</li>
                <li>• 주말: 10% 할증</li>
                <li>• 프리미엄 좌석: 20% 할증</li>
                <li>• 높은 수요시: 20% 할증</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeatReservationPage;